<template>
  <div class="form-signup-form">
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <md-card class="no-shadow md-layout-item md-size-100">
        <md-card-header>
          <div class="md-title">Sign Up</div>
        </md-card-header>

        <md-card-content>
          <md-field :class="getValidationClass('email')">
            <label for="email">Email</label>
            <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
            <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
          </md-field>

          <md-field :class="getValidationClass('username')">
            <label for="username">Username</label>
            <md-input type="text" name="username" id="username" autocomplete="username" v-model="form.username" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.username.required">The username is required</span>
            <span class="md-error" v-else-if="!$v.form.username.username">Invalid username</span>
          </md-field>

          <md-field :class="getValidationClass('firstname')">
            <label for="firstname">Firstname</label>
            <md-input type="text" name="firstname" id="firstname" autocomplete="firstname" v-model="form.firstname" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.firstname.required">The firstname is required</span>
            <span class="md-error" v-else-if="!$v.form.firstname.firstname">Invalid firstname</span>
          </md-field>

          <md-field :class="getValidationClass('lastname')">
            <label for="lastname">Lastname</label>
            <md-input type="text" name="lastname" id="lastname" autocomplete="lastname" v-model="form.lastname" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.lastname.required">The lastname is required</span>
            <span class="md-error" v-else-if="!$v.form.lastname.lastname">Invalid lastname</span>
          </md-field>

          <md-field :class="getValidationClass('password')">
            <label for="password">Password</label>
            <md-input type="password" name="password" id="password" autocomplete="off" v-model="form.password" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.password.required">The password is required</span>
            <span class="md-error" v-else-if="!$v.form.password.password">Invalid password</span>
            <span class="md-error" v-else-if="!$v.form.password.minLength">The passwort must be at least 8 characters long.</span>
          </md-field>

          <error-container :error="error"></error-container>

        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <md-button type="button" class="md-primary">
            <router-link to="/login">Sign in instead</router-link>
          </md-button>
          <md-button type="submit" class="md-raised md-primary" :disabled="sending">
            <span v-show="!sending">
              Sign Up
            </span>
            <span v-show="sending">
              <md-progress-spinner
                :md-diameter="22"
                :md-stroke="2"
                md-mode="indeterminate"
              />
            </span>
          </md-button>
        </md-card-actions>
      </md-card>

      <md-snackbar :md-active.sync="userSaved">The user {{ lastUser }} was saved with success!</md-snackbar>
    </form>
  </div>
</template>

<script>
import ErrorContainer from '../ErrorContainer'
import { validationMixin } from 'vuelidate'
import {
  required,
  email,
  alphaNum,
  minLength
} from 'vuelidate/lib/validators'

export default {
  name: 'SignupForm',
  mixins: [validationMixin],
  components: {
    ErrorContainer
  },
  data: () => ({
    form: {
      email: null,
      username: null,
      firstname: null,
      lastname: null,
      password: null
    },
    userSaved: false,
    sending: false,
    lastUser: null,
    error: null
  }),
  validations: {
    form: {
      email: {
        required,
        email
      },
      username: {
        required,
        alphaNum
      },
      firstname: {
        required
      },
      lastname: {
        required
      },
      password: {
        required,
        minLength: minLength(8)
      }
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm () {
      this.$v.$reset()
      this.form.email = null
      this.form.username = null
      this.form.firstname = null
      this.form.lastname = null
      this.form.password = null
    },
    async saveUser () {
      this.sending = true
      try {
        await this.$store.dispatch('signup', {
          email: this.form.email,
          username: this.form.username,
          firstname: this.form.firstname,
          lastname: this.form.lastname,
          password: this.form.password
        })

        this.$router.push('/login?new=true')
      } catch (error) {
        this.error = error
      } finally {
        this.sending = false
      }
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.saveUser()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-signup-form {
  .md-progress-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }
  .no-shadow  {
    box-shadow: none;
  }
  .md-title {
    text-align: left;
  }
  .md-error {
    color: red;
  }
  circle.md-progress-spinner-circle {
    stroke: rgba(0, 0, 0, 0.26) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/SignupForm.vue